import CreateGroup from './creategroup/index.vue';
import ConnectionGroupMapping from './ConnectionGroupMapping/index.vue';
import MigrateDestinations from './MigrateDestinations/index.vue';
import AddNewDestinationToGroup from './AddNewDestinationToGroup/index.vue';
import AllocateGroupsToConnection from './AllocateGroupsToConnection/index.vue';
import UpdateParentHub from './UpdateParentHub/index.vue';

export default {
	name: 'groupnew',
	components: {
		'first': CreateGroup,
		'second': ConnectionGroupMapping,
		'third': MigrateDestinations,
		'fourth': AddNewDestinationToGroup,
		'fifth': AllocateGroupsToConnection,
		'sixth': UpdateParentHub,
	},
	props: [],
	data() {
		return {
			currentTab: 'First',
			componentKey: 0,
			tabs: [
				{
					key: 'First',
					value: 'Create Group'
				},
				{
					key: 'Second',
					value: 'Manage Group'
				},
				{
					key: 'Third',
					value: 'Migrate Destinations'
				},
				{
					key: 'Fourth',
					value: 'Add New Destination To Group'
				},
				{
					key: 'Fifth',
					value: 'Allocate Groups To connection'
				},
				{
					key: 'Sixth',
					value: 'Update Parent Hub'
				}

			],
		}
	},
	computed: {
		currentTabComponent: function () {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		}
	},
	mounted() { },
	methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/groupnew/groupnew.js